export default __webpack_public_path__ + "static/media/img5.91522d11.PNG";